module.exports = __webpack_public_path__ + "img/GanzSchönFrech.2f34a901.jpg";